import React from 'react';
import s from './Logo.scss';
import WixLogoImage from './logo-wix.svg';
import { Box } from '@wix/design-system';

type LogoProps = {
  height?: number;
};

export const Logo = ({ height }: LogoProps) => {
  return (
    <div className={s.logo} style={{ height }}>
      <Box gap="2px" verticalAlign="middle">
        <WixLogoImage height={height} color="#000000" />
      </Box>
    </div>
  );
};
